export default __webpack_public_path__ + "img/4e03f1380a54087d1f40d29e9777564b.png";